// useForm.js
import { useState } from 'react';
import { _setAxios, _success } from 'lib/Helper';

const useExport = (privilege, hideModal) => {
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState({
        tahun_ajaran_id: parseInt(privilege?.tahun_ajaran?.id),
        semester_id: privilege?.semester?.id,
    });

    const handleSubmit = (val) => {
        setLoading(true);
        let endpoint = "rombel/export";
        let method = "POST";

        _setAxios(endpoint, method, {
            tahun_ajaran_id: val.tahun_ajaran_id || null,
            semester_id: val.semester_id || null,
        }).then(resp => {
            if (resp.status) {
                _success('topRight', 'Success', resp.data.message)
                hideModal();
                if (!resp.data?.data?.link) {
                    setLoading(false);
                    return
                }
                setTimeout(() => {
                    window.location.href = resp.data?.data?.link
                }, 300);
            }
            setLoading(false);
        }).catch(err => {
            setLoading(false);
        });
    };

    const handleChangeSetValue = (name, value) => {
        setValues(prevValues => ({ ...prevValues, [name]: value }));
    };

    return {
        values,
        setValues,
        handleChangeSetValue,
        loading,
        handleSubmit,
    };
};

export default useExport;
